var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('div',{staticClass:"title"},[_vm._v("服务医生")]),_c('a-table',{staticStyle:{"margin-bottom":"24px"},attrs:{"columns":_vm.columns,"dataSource":_vm.doctor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }